const PLACEHOLDER_LABEL_OVERRIDES: Record<string, string> = {
  zip: 'Zip Code'
}

const toTitleCase = (key: string): string =>
  key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim()

export const formatPlaceholderLabel = (key: string, label?: string): string => {
  if (!key) return ''
  const override = PLACEHOLDER_LABEL_OVERRIDES[key]
  if (override) return override
  if (label) return label
  return toTitleCase(key)
}
